<template>
    <div component="VideoPlayer">
        {{ url }}
        <video ref="video" id="video-player" playsinline="" autoplay="" controls="">
            <source :src="url" type="video/mp4" />
        </video>
    </div>
</template>

<script>
import Btn from '@/components/.global/Btn.vue';
export default {
    name: 'VideoPlayer',

    mounted() {
        this.$refs.video.addEventListener('ended', () => {
            this.$emit('ended');
        });

        this.$refs.video.addEventListener('pause', () => {
            this.$emit('pause');
        });

        this.$refs.video.addEventListener('play', () => {
            this.$emit('play');
        });
    },

    props: {
        url: {
            type: String,
            required: true,
        },
    },

    components: {
        Btn,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='VideoPlayer'] {
    width: 100%;
    height: 100%;
    background-color: black;
    overflow: hidden;
    .radiusBig;

    video {
        width: 100%;
        height: 100%;
    }
}
</style>
